import { buildWhatsAppUrl, site } from '../data/site.js';
import { getAttribution } from './tracking.js';
import { hasMarketingConsent } from './consent.js';

const STORAGE_KEY = 'contdesk-lead';
let memoryLead = null;

export function createProtocol() {
  const now = new Date();
  const stamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;
  const suffix = String(now.getTime()).slice(-4);
  return `CD-${stamp}-${suffix}`;
}

export function saveLead(lead) {
  memoryLead = lead;
  try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(lead)); } catch { /* Mantém a ficha nesta página quando o armazenamento está bloqueado. */ }
  return lead;
}

export function getLead() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null') || memoryLead;
  } catch {
    return memoryLead;
  }
}

export function formatLeadMessage(lead) {
  const attribution = hasMarketingConsent() ? (lead.attribution || getAttribution()) : {};
  const origin = Object.entries(attribution)
    .map(([key, value]) => `${key}: ${value}`)
    .join(' | ');

  return [
    'Olá, quero conhecer o ContDesk e agendar uma demonstração.',
    '',
    `Protocolo: ${lead.protocol}`,
    `Nome: ${lead.name}`,
    `Escritório: ${lead.office}`,
    `WhatsApp: ${lead.whatsapp}`,
    `Carteira: ${lead.portfolio}`,
    `Sistema atual: ${lead.system}`,
    `Plano de interesse: ${lead.plan || 'Quero ajuda para escolher'}`,
    origin ? `Origem: ${origin}` : null,
  ]
    .filter(Boolean)
    .join('\n');
}

export function leadWhatsAppUrl(lead) {
  return buildWhatsAppUrl(formatLeadMessage(lead));
}

export function leadMailtoUrl(lead) {
  const subject = encodeURIComponent(`Demonstração ContDesk — ${lead.protocol}`);
  const body = encodeURIComponent(formatLeadMessage(lead));
  return `mailto:${site.email}?subject=${subject}&body=${body}`;
}

export function formatPhone(value) {
  const digits = value.replace(/\D/g, '').slice(0, 11);

  if (digits.length <= 2) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }

  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}
